import { render, staticRenderFns } from "./BatchActionsModal.vue?vue&type=template&id=27c55d64&"
import script from "./BatchActionsModal.vue?vue&type=script&lang=js&"
export * from "./BatchActionsModal.vue?vue&type=script&lang=js&"
import style0 from "./BatchActionsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports